import SoftooMap from "../Map";
import Map from "ol/Map";
import LineString from "ol/geom/LineString";
import Feature from "ol/Feature";

import { Coordinate, IMeasureResult, IMovedFeature } from "../types";
import { Drawer } from "./Drawer";

export class MoveFeature extends Drawer {
  private $map: SoftooMap;
  private target: Feature; // the feature to be moved
  private originalTarget: Feature;
  private coordinate: Coordinate;
  
  constructor(options) {
    let afterMoved;
    options = options || {}
    if (options.source) {
      delete options.source; // we don't need to keep the drawing
    }
    if (options.afterMoved) {
      afterMoved = options.afterMoved;
      delete options.afterMoved;
    }
    options.type = 'LineString'; // drawing a line to show moving distance
    super(Object.assign({
      maxPoints: 2 // force to stop drawing after adding second point
    }, options));
    if (afterMoved) {
      this.afterMoved = afterMoved;
    }
  }

  startDraw(event) {
    if (!this.target && this.$map.map.HighlightedFeature) {
      let f = this.$map.map.HighlightedFeature;
      this.$map.selectFeature(f);
      this.originalTarget = this.$map.cloneFeature(f);
      this.target = f;
      this['abortDrawing_']();
    }
    else if (this.target) {
      if (!this.coordinate) {
        this.coordinate = this['sketchCoords_'][0].map((c) => {
          return c; // IMPORTANT: to clone the coordinate in order to measure distance of move correctly
        });
      }
      super.startDraw(event);
    }
  }
  
  measureDistance(geom:LineString) : IMeasureResult {
    let result = super.measureDistance(geom);
    if (this.target) {
      // handle move feature
      let coordinate = this['sketchCoords_'][1]; //geom.getCoordinates()[1];
      let deltaX = coordinate[0] - this.coordinate[0];
      let deltaY = coordinate[1] - this.coordinate[1];
      let geometry = this.target.getGeometry();
      geometry.translate(deltaX, deltaY);
      this.coordinate = [coordinate[0], coordinate[1]];
    }
    return result;
  }
  
  endDraw(event) {
    let c1 = this['sketchCoords_'][0];
    let c2 = this['sketchCoords_'][1];
    if ((c1[0]!=c2[0] || c1[1]!=c2[1]) && this.target) {
      this.$map.clearLayer('SelectedFeatureLayer');
      this.$map.addUndo(this.originalTarget, 'Update');
      this.target.set('STATE', 'Update');
      this.afterMoved({
        original: this.originalTarget,
        modified: this.target
      });
      this.coordinate = null;
      this.target = null;
      this.originalTarget = null;
    }
    super.endDraw(event);
  }

  discardDraw() {
    if (this.target) {
      this.$map.clearLayer('SelectedFeatureLayer');
      this.target.setGeometry(this.originalTarget.getGeometry());
      this.coordinate = null;
      this.target = null;
      this.originalTarget = null;
    }
    this['abortDrawing_']();
    super.endDraw({feature: this.sketch});
  }

  afterMoved(moved:IMovedFeature) {
    // to be override by application
  }

  setMap(map:Map) {
    if (map) {
      this.$map = map['SOFTOO_MAP'];
    }
    super.setMap(map);
  }

  remove() {
    super.remove();
  }
}